var map = {
	"./SberZvukLogo.svg": 1408,
	"./apple-music.svg": 9285,
	"./appleMusic_logo copy.svg": 8681,
	"./appleMusic_logo.svg": 119,
	"./boom_logo.svg": 5306,
	"./complete.svg": 9872,
	"./deezer_logo.svg": 4096,
	"./error.svg": 8498,
	"./fonts/SBSansDisplay-Bold.eot": 7218,
	"./fonts/SBSansDisplay-Bold.ttf": 7722,
	"./fonts/SBSansDisplay-Bold.woff": 5003,
	"./fonts/SBSansDisplay-Bold.woff2": 2344,
	"./fonts/SBSansDisplay-Bold_1.eot": 312,
	"./fonts/SBSansDisplay-Bold_1.ttf": 7522,
	"./fonts/SBSansDisplay-Bold_1.woff": 4938,
	"./fonts/SBSansDisplay-Bold_1.woff2": 7146,
	"./fonts/SBSansDisplay-Light.eot": 4859,
	"./fonts/SBSansDisplay-Light.ttf": 1751,
	"./fonts/SBSansDisplay-Light.woff": 412,
	"./fonts/SBSansDisplay-Light.woff2": 2026,
	"./fonts/SBSansDisplay-Light_1.eot": 1444,
	"./fonts/SBSansDisplay-Light_1.ttf": 7667,
	"./fonts/SBSansDisplay-Light_1.woff": 9981,
	"./fonts/SBSansDisplay-Light_1.woff2": 8400,
	"./fonts/SBSansDisplay-Regular.eot": 7492,
	"./fonts/SBSansDisplay-Regular.ttf": 1314,
	"./fonts/SBSansDisplay-Regular.woff": 9481,
	"./fonts/SBSansDisplay-Regular.woff2": 4319,
	"./fonts/SBSansDisplay-Regular_1.eot": 2853,
	"./fonts/SBSansDisplay-Regular_1.ttf": 3426,
	"./fonts/SBSansDisplay-Regular_1.woff": 8741,
	"./fonts/SBSansDisplay-Regular_1.woff2": 7364,
	"./fonts/SBSansDisplay-Semibold.eot": 1782,
	"./fonts/SBSansDisplay-Semibold.ttf": 2335,
	"./fonts/SBSansDisplay-Semibold.woff": 9414,
	"./fonts/SBSansDisplay-Semibold.woff2": 3011,
	"./fonts/SBSansDisplay-Semibold_1.eot": 2405,
	"./fonts/SBSansDisplay-Semibold_1.ttf": 9098,
	"./fonts/SBSansDisplay-Semibold_1.woff": 5283,
	"./fonts/SBSansDisplay-Semibold_1.woff2": 8761,
	"./fonts/SBSansDisplay-Thin.eot": 6697,
	"./fonts/SBSansDisplay-Thin.ttf": 6096,
	"./fonts/SBSansDisplay-Thin.woff": 3144,
	"./fonts/SBSansDisplay-Thin.woff2": 6628,
	"./fonts/SBSansDisplay-Thin_1.eot": 4420,
	"./fonts/SBSansDisplay-Thin_1.ttf": 9630,
	"./fonts/SBSansDisplay-Thin_1.woff": 9834,
	"./fonts/SBSansDisplay-Thin_1.woff2": 9776,
	"./icons/album_icon.svg": 4776,
	"./icons/arrow-thin.svg": 6902,
	"./icons/arrow.svg": 5090,
	"./icons/check.svg": 706,
	"./icons/completed.svg": 9138,
	"./icons/library.svg": 7900,
	"./icons/playlist_icon.svg": 4501,
	"./icons/reload.svg": 6939,
	"./icons/track_icon.svg": 8104,
	"./js/pb/bus_pb": 6125,
	"./js/pb/bus_pb.js": 6125,
	"./js/pb/error_pb": 8695,
	"./js/pb/error_pb.js": 8695,
	"./js/pb/job_pb": 6796,
	"./js/pb/job_pb.js": 6796,
	"./js/pb/media_pb": 8397,
	"./js/pb/media_pb.js": 8397,
	"./js/pb/oauth_pb": 2689,
	"./js/pb/oauth_pb.js": 2689,
	"./js/pb/platform_pb": 5333,
	"./js/pb/platform_pb.js": 5333,
	"./js/pb/result_pb": 9458,
	"./js/pb/result_pb.js": 9458,
	"./js/pb/svc.core.msg_pb": 9912,
	"./js/pb/svc.core.msg_pb.js": 9912,
	"./js/pb/svc.core.rpc_grpc_web_pb": 76,
	"./js/pb/svc.core.rpc_grpc_web_pb.js": 76,
	"./js/pb/svc.core.rpc_pb": 8013,
	"./js/pb/svc.core.rpc_pb.js": 8013,
	"./js/pb/svc.sberzvuk.msg_pb": 7517,
	"./js/pb/svc.sberzvuk.msg_pb.js": 7517,
	"./js/pb/svc.sberzvuk.rpc_grpc_web_pb": 33,
	"./js/pb/svc.sberzvuk.rpc_grpc_web_pb.js": 33,
	"./js/pb/svc.sberzvuk.rpc_pb": 6269,
	"./js/pb/svc.sberzvuk.rpc_pb.js": 6269,
	"./js/pb/svc.spotify.rpc_grpc_web_pb": 6494,
	"./js/pb/svc.spotify.rpc_grpc_web_pb.js": 6494,
	"./js/pb/svc.spotify.rpc_pb": 7831,
	"./js/pb/svc.spotify.rpc_pb.js": 7831,
	"./js/pb/user_pb": 4208,
	"./js/pb/user_pb.js": 4208,
	"./playMusic_logo.svg": 538,
	"./spinner.svg": 5522,
	"./spotify_logo.svg": 346,
	"./vk_logo.svg": 9893,
	"./yandexMusic_logo copy.svg": 4138,
	"./yandexMusic_logo.svg": 9654,
	"./zvook_logo_small.svg": 2658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;